'use client'

import React, { useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'

import PackageSearch from './packageSearch'

/** How long each destination holds before the next one flips in. */
const HINT_INTERVAL_MS = 2600

interface PackageSearchWrapperProps {
    /** Field id — the grid namespaces it, so a page may carry more than one grid. */
    id: string
    value: string
    /** Destinations to flip through, in the order the grid shows them. */
    suggestions: string[]
    onChange: (value: string) => void
    onClear: () => void
    isMobile: boolean
}

const PackageSearchWrapper: React.FC<PackageSearchWrapperProps> = ({
    id,
    value,
    suggestions,
    onChange,
    onClear,
    isMobile
}) => {
    const t = useTranslations('holidaysPage')
    const [hintIndex, setHintIndex] = useState(0)

    useEffect(() => {
        // One destination is not a rotation, and a typed query hides the hint anyway.
        if (suggestions.length < 2 || value) return undefined

        const timer = window.setInterval(() => {
            setHintIndex(current => (current + 1) % suggestions.length)
        }, HINT_INTERVAL_MS)

        return () => window.clearInterval(timer)
    }, [suggestions.length, value])

    const suggestion = suggestions[hintIndex % suggestions.length]

    return (
        <PackageSearch
            id={id}
            value={value}
            placeholder={t('searchPackagesPlaceholder')}
            hint={suggestion ? t('searchHint', { destination: suggestion }) : undefined}
            hintKey={hintIndex}
            clearLabel={t('clearSearch')}
            onChange={onChange}
            onClear={onClear}
            isMobile={isMobile}
        />
    )
}

export { PackageSearchWrapper }
export default PackageSearchWrapper
